import React from 'react';
import { STYLES } from 'utils/constants/styles';
import styled from 'styled-components';
import { FreeResultInfo, InfoFooter, PaidMedicalReportInfo } from 'components/copy-of-medical-reports';
import { PrimaryButton } from 'components/common/button';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import ROUTES from 'utils/constants/routes.json';

const StyledFooter = styled.div`
    padding-top: ${STYLES.CONTENT_PADDING_TOP};
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${STYLES.CONTENT_PADDING_TOP};
    text-align: center;
    max-width: 50%;
    margin: 0 auto;
    color: ${props => props.theme.text.black} !important;

    @media screen and (max-width: 800px) {
        max-width: 80%;
    }
`;

const CopyOfMedicalClerking: React.FC = () => {
    const { t } = useTranslation('common');

    return (
        <StyledFooter>
            <FreeResultInfo />
            <PaidMedicalReportInfo />
            <InfoFooter />

            <PrimaryButton>
                <Link to={ROUTES.base}>{t('return')}</Link>
            </PrimaryButton>
        </StyledFooter>
    );
};

export default CopyOfMedicalClerking;
